import 'bootstrap.collapse';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import 'global';
import '/assets/theme/js/mmenu-light.js?v=2';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        registerComponents(components);

    // Add class sticky to menu on scroll.
    const header = document.getElementById('header');

    window.addEventListener('scroll', () => {
        if (window.scrollY >= 50)
            header.classList.add('sticky-styles');
        else
            header.classList.remove('sticky-styles');
    });

    // Scroll reveal styles.
    const elementsToFadeInUpOnScroll = context.querySelectorAll('.scroll-reveal');

    if (elementsToFadeInUpOnScroll.length > 0) {
        window.addEventListener('scroll', () => {
            elementsToFadeInUpOnScroll.forEach(element => {
                let positionFromTop = element.getBoundingClientRect().top;

                if (positionFromTop <= window.innerHeight && positionFromTop >= 0)
                    element.classList.add('fade-in-up');
            });
        });
    }

    // Mobile Menu
    const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 991px)');

    menu.navigation({
        slidingSubmenus: true,
        title: 'Menu'
    });

    const drawer = menu.offcanvas({
        position: 'left'
    });

    // Open the menu.
    document.querySelector('button[href="#menu-navbar"]')
        .addEventListener('click', e => {
            e.preventDefault();
            drawer.open();
        });
}